export default "__VITE_ASSET__DaW70wqX__"